module.exports = __webpack_public_path__ + "static/media/month-avatar.d98e21ba.svg";